import React, { useEffect, useState } from 'react';
import { Form, InputNumber, Button, DatePicker, Select, Spin, Card, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';

const { Option } = Select;

const UserAttributesUpdate = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [attributesId, setAttributesId] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [timezones, setTimezones] = useState([]);

  useEffect(() => {
    async function fetchAttributes() {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/user-attributes/`,
          { withCredentials: true }
        );
        const dataItem = data[0];
        console.log(dataItem);

        setAttributesId(dataItem.id);
        form.setFieldsValue({
          gender: dataItem.gender,
          dateOfBirth: dayjs(dataItem.dateOfBirth),
          heightQuantity: dataItem.heightQuantity,
          heightType: dataItem.heightType,
          timezone: dataItem.timezone
        });
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setAttributesId(null);
          form.resetFields();
        } else {
          messageApi.error('Failed to load user attributes');
        }
      }
      setLoading(false);
    }
    fetchAttributes();
    fetchTimezones();
  }, [form, messageApi]);



    async function fetchTimezones() {
      try {
        // Example API endpoint for timezone list; replace with your actual API or a public source if needed
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user-attributes/timezones`,
          { withCredentials: true });
        setTimezones(data);
      } catch {
        messageApi.error('Failed to load timezones');
      }
    }


  const onFinish = async (values) => {
    setSaving(true);
    try {
      const payload = {
        ...values,
        dateOfBirth: values.dateOfBirth.format('YYYY-MM-DD'),
      };

      if (attributesId) {
        await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/user-attributes/${attributesId}`,
          payload,
          { withCredentials: true }
        );
        messageApi.success('User attributes updated!');
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/user-attributes`,
          payload,
          { withCredentials: true }
        );
        setAttributesId(data.id);
        messageApi.success('User attributes created!');
      }
    } catch (e) {
      messageApi.error('Failed to save user attributes');
    }
    setSaving(false);
  };

  return (
    <Card title="Update Your Attributes" style={{ maxWidth: 430, margin: 'auto' }}>
      {contextHolder}
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: 'Please choose your gender' }]}
          >
            <Select>
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="dateOfBirth"
            label="Date of Birth"
            rules={[{ required: true, message: 'Please select your date of birth' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="heightQuantity"
            label="Height"
            rules={[{ required: true, message: 'Please enter your height' }]}
          >
            <InputNumber min={0} precision={2} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="heightType"
            label="Height Unit"
            rules={[{ required: true, message: 'Please select a height unit' }]}
          >
            <Select>
              <Option value="metric">Metres</Option>
              <Option value="imperial">Feet (as decimal)</Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="timezone"
            label="Timezone"
            rules={[{ required: true, message: 'Please select a timezone' }]}
          >
            <Select
              showSearch
              placeholder="Select a timezone"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              loading={timezones.length === 0}
            >
              {timezones.map((tz) => (
                <Option key={tz} value={tz}>
                  {tz}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving} block>
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default UserAttributesUpdate;
